import { render, staticRenderFns } from "./form-setup.vue?vue&type=template&id=8fd4c328&scoped=true&"
import script from "./form-setup.vue?vue&type=script&lang=js&"
export * from "./form-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd4c328",
  null
  
)

export default component.exports